import { money } from "../lib/api";

export function printHTML(html) {
  const w = window.open("", "_blank", "width=900,height=1000");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
  // Give the new window a moment to load fonts, then print
  setTimeout(() => {
    try { w.focus(); w.print(); } catch (e) { /* ignore */ }
  }, 350);
}

const baseStyles = `
<style>
  @page { size: A4; margin: 18mm; }
  * { box-sizing: border-box; }
  body { font-family: 'Manrope', system-ui, -apple-system, sans-serif; color: #102a2b; margin: 0; padding: 0; }
  .doc { max-width: 800px; margin: 0 auto; padding: 24px; }
  .brand { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 18px; border-bottom: 2px solid #0f766e; margin-bottom: 22px; }
  .brand h1 { margin: 0 0 4px; font-size: 22px; letter-spacing: -.5px; color: #0f766e; }
  .brand small { color: #678080; font-size: 11px; display: block; line-height: 1.5; }
  .doc-title { text-align: right; }
  .doc-title h2 { margin: 0; font-size: 20px; letter-spacing: -.5px; }
  .doc-title .muted { font-size: 11px; color: #678080; margin-top: 4px; }
  .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin: 20px 0 24px; }
  .card { background: #f7fbfa; border: 1px solid #dce8e5; border-radius: 8px; padding: 12px 14px; }
  .card p { margin: 0 0 4px; font-size: 9px; color: #678080; letter-spacing: .1em; font-weight: 700; }
  .card strong { font-size: 13px; display: block; }
  .card span { display: block; font-size: 11px; color: #45615e; margin-top: 2px; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; }
  th { text-align: left; font-size: 9px; letter-spacing: .1em; text-transform: uppercase; padding: 10px 8px; border-bottom: 1.5px solid #0f766e; color: #0f766e; }
  td { padding: 10px 8px; border-bottom: 1px solid #edf3f1; font-size: 11px; color: #45615e; }
  td.right, th.right { text-align: right; }
  tfoot td { border-top: 1.5px solid #0f766e; border-bottom: 0; font-weight: 700; color: #102a2b; padding-top: 12px; }
  .totals { margin-top: 20px; margin-left: auto; width: 300px; }
  .totals .row { display: flex; justify-content: space-between; padding: 6px 0; font-size: 12px; }
  .totals .row.big { border-top: 1.5px solid #0f766e; margin-top: 6px; padding-top: 12px; font-weight: 800; font-size: 15px; color: #0f766e; }
  .sig-row { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-top: 60px; }
  .sig-row div { border-top: 1px solid #102a2b; padding-top: 6px; font-size: 11px; }
  .sig-row small { color: #678080; display: block; margin-top: 2px; font-size: 10px; }
  .footer { text-align: center; margin-top: 40px; font-size: 10px; color: #89a09e; }
  .badge { display: inline-block; background: #dff4ee; color: #0f766e; font-size: 10px; padding: 3px 8px; border-radius: 4px; font-weight: 700; }
  @media print { .no-print { display: none; } }
</style>
<link href="https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&display=swap" rel="stylesheet">
`;

export function printReceipt(receipt, company) {
  const lines = receipt.items || [];
  const total = receipt.total || 0;
  const subtotal = lines.reduce((s, l) => s + Number(l.qty || 0) * Number(l.rate || 0), 0);
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>GRN ${receipt.id}</title>${baseStyles}</head>
  <body><div class="doc">
    <div class="brand">
      <div>
        <h1>${company?.name || "MediStore Central"}</h1>
        <small>${company?.hospital || ""}<br>${company?.address || ""}</small>
        <small>${company?.phone || ""} · ${company?.email || ""}</small>
        <small>GSTIN: ${company?.gstin || "—"}</small>
      </div>
      <div class="doc-title">
        <span class="badge">GOODS RECEIPT NOTE</span>
        <h2>${receipt.invoice_number || receipt.id}</h2>
        <div class="muted">GRN ID · ${receipt.id}</div>
        <div class="muted">Date · ${receipt.invoice_date || ""}</div>
      </div>
    </div>
    <div class="grid-2">
      <div class="card">
        <p>SUPPLIER</p>
        <strong>${receipt.vendor || "—"}</strong>
        <span>Invoice: ${receipt.invoice_number || "—"}</span>
        <span>Date: ${receipt.invoice_date || "—"}</span>
      </div>
      <div class="card">
        <p>RECEIVED BY</p>
        <strong>${receipt.received_by || "Store In-charge"}</strong>
        <span>Payment status: ${receipt.payment_status || "Unpaid"}</span>
        <span>Amount paid: ${money(receipt.amount_paid || 0)}</span>
      </div>
    </div>
    <table>
      <thead><tr>
        <th>#</th><th>Item</th><th>Batch</th><th>Expiry</th>
        <th class="right">Qty</th><th class="right">Unit</th><th class="right">Rate</th><th class="right">Amount</th>
      </tr></thead>
      <tbody>
        ${lines.map((l, i) => `<tr>
          <td>${i + 1}</td>
          <td>${l.item || ""}</td>
          <td>${l.batch || "—"}</td>
          <td>${l.expiry || "—"}</td>
          <td class="right">${Number(l.qty || 0).toLocaleString("en-IN")}</td>
          <td class="right">${l.unit || ""}</td>
          <td class="right">${money(l.rate || 0)}</td>
          <td class="right">${money(Number(l.qty || 0) * Number(l.rate || 0))}</td>
        </tr>`).join("")}
      </tbody>
    </table>
    <div class="totals">
      <div class="row"><span>Subtotal</span><span>${money(subtotal)}</span></div>
      <div class="row"><span>Payment made</span><span>${money(receipt.amount_paid || 0)}</span></div>
      <div class="row big"><span>Grand total</span><span>${money(total)}</span></div>
    </div>
    ${receipt.notes ? `<p style="margin-top:20px;font-size:11px;color:#678080"><b>Notes:</b> ${receipt.notes}</p>` : ""}
    <div class="sig-row">
      <div>${receipt.received_by || "Store In-charge"}<small>Received by (Store)</small></div>
      <div>${receipt.vendor || ""}<small>Supplier signature</small></div>
    </div>
    <div class="footer">Generated by MediStore Inventory · ${new Date().toLocaleString("en-IN")}</div>
  </div></body></html>`;
  printHTML(html);
}

export function printIndent(indent, company) {
  const lines = indent.items || [];
  const issued = indent.issued_lines || [];
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Indent ${indent.id}</title>${baseStyles}</head>
  <body><div class="doc">
    <div class="brand">
      <div>
        <h1>${company?.name || "MediStore Central"}</h1>
        <small>${company?.hospital || ""}<br>${company?.address || ""}</small>
        <small>${company?.phone || ""} · ${company?.email || ""}</small>
      </div>
      <div class="doc-title">
        <span class="badge">DEPARTMENT INDENT</span>
        <h2>${indent.indent_number || indent.id}</h2>
        <div class="muted">Status · ${indent.status || "—"}</div>
        <div class="muted">Indent date · ${indent.indent_date || ""}</div>
      </div>
    </div>
    <div class="grid-2">
      <div class="card">
        <p>ISSUED TO</p>
        <strong>${indent.department || "—"} Department</strong>
        <span>Raised by: ${indent.raised_by || "—"} (${indent.raised_by_role || "—"})</span>
        <span>Issue date: ${indent.issue_date || "—"}</span>
      </div>
      <div class="card">
        <p>DELIVERY</p>
        <strong>${indent.delivered_by || "— pending —"}</strong>
        <span>Delivered on: ${indent.delivered_date || "—"}</span>
        <span>Received by: ${indent.received_by || "—"} · ${indent.received_date || "—"}</span>
      </div>
    </div>
    <table>
      <thead><tr><th>#</th><th>Item</th><th>Batch requested</th><th class="right">Qty</th><th class="right">Unit</th></tr></thead>
      <tbody>
        ${lines.map((l, i) => `<tr>
          <td>${i + 1}</td>
          <td>${l.name || ""}</td>
          <td>${l.batch || "—"}</td>
          <td class="right">${Number(l.qty || 0).toLocaleString("en-IN")}</td>
          <td class="right">${l.unit || ""}</td>
        </tr>`).join("")}
      </tbody>
    </table>
    ${issued.length ? `
      <h3 style="margin-top:26px;font-size:14px;color:#0f766e">FIFO Batch pick log</h3>
      <table><thead><tr><th>Item</th><th>Batch</th><th class="right">Qty picked</th><th>Expiry</th></tr></thead>
      <tbody>
        ${issued.flatMap((il) => (il.picks || []).map((p) => `<tr>
          <td>${il.name}</td><td>${p.batch}</td><td class="right">${Number(p.qty).toLocaleString("en-IN")} ${il.unit || ""}</td><td>${p.expiry || "—"}</td>
        </tr>`)).join("")}
      </tbody></table>
    ` : ""}
    ${indent.remarks || indent.notes ? `<p style="margin-top:20px;font-size:11px;color:#678080"><b>Notes:</b> ${indent.remarks || indent.notes}</p>` : ""}
    <div class="sig-row">
      <div>${indent.delivered_by || "___________________"}<small>Delivered by (Store In-charge)</small></div>
      <div>${indent.received_by || "___________________"}<small>Received by (Department)</small></div>
    </div>
    <div class="footer">Generated by MediStore Inventory · ${new Date().toLocaleString("en-IN")}</div>
  </div></body></html>`;
  printHTML(html);
}
